// extracted by mini-css-extract-plugin
module.exports = {"centered":"styles_centered__h4LgD"};